__turbopack_context__.v({
  "attachment": "CKEe4q_attachment",
  "container": "CKEe4q_container",
  "lineItemSummary": "CKEe4q_lineItemSummary",
  "notes": "CKEe4q_notes",
  "withAttachment": "CKEe4q_withAttachment",
  "withNotes": "CKEe4q_withNotes",
});
